var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoTestSuitesYet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#F0F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.3324 41.3311H73.9986C75.2362 41.3311 76.423 41.8228 77.2981 42.698C78.1732 43.5733 78.6648 44.7604 78.6648 45.9981V78.6674C78.6648 79.9052 78.1732 81.0923 77.2981 81.9675C76.423 82.8428 75.2362 83.3345 73.9986 83.3345H46.0014C44.7639 83.3345 43.577 82.8428 42.7019 81.9675C41.8268 81.0923 41.3352 79.9052 41.3352 78.6674V45.9981C41.3352 44.7604 41.8268 43.5733 42.7019 42.698C43.577 41.8228 44.7639 41.3311 46.0014 41.3311H50.6676M53.0007 64.6663L57.6669 69.3333L66.9993 59.9993M53.0007 36.6641H66.9993C68.2878 36.6641 69.3324 37.7088 69.3324 38.9976V43.6646C69.3324 44.9534 68.2878 45.9981 66.9993 45.9981H53.0007C51.7122 45.9981 50.6676 44.9534 50.6676 43.6646V38.9976C50.6676 37.7088 51.7122 36.6641 53.0007 36.6641Z",
    stroke: "#005BF0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTestSuitesYet);
export default __webpack_public_path__ + "static/media/no_test_suites_yet.be2db85e2a5f764b26bc143c1dcede55.svg";
export { ForwardRef as ReactComponent };